import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import { Heading } from "../Heading";

import styles from "./LegalConsent.scss";

const LegalConsentHeading = forwardRef(
  ({ children, tag, ...otherProps }, ref) => {
    return (
      <Heading
        ref={ref}
        tag={tag}
        variants={[
          Heading.Variant.quaternary,
          Heading.Variant.highlight,
          styles.heading,
        ]}
        {...otherProps}
      >
        {children}
      </Heading>
    );
  }
);

LegalConsentHeading.defaultProps = {
  tag: "h2",
};

LegalConsentHeading.propTypes = {
  tag: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

LegalConsentHeading.displayName = "LegalConsent.Heading";

export default LegalConsentHeading;
